import React from 'react';
import BaseType from './BaseType';

const FollowUp = ({ items, children, count, time, onClick, expanded }) => {
  return (
    <BaseType
      logos={items.map((item) => {
        return item?.metadata?.prospect?.logo_url;
      })}
      mainText={`${count} prospects`}
      tagText='Follow-ups sent'
      tagType='neutral'
      time={time}
      onClick={onClick}
      expanded={expanded}
    >
      {children}
    </BaseType>
  );
};

export default FollowUp;
